<template>
  <v-dialog v-model="dialogProxy" max-width="1200">
    <v-card>
      <v-card-title>
        Laadunvalvonta
        <v-spacer/>
        <v-btn icon @click="addQCItem"><v-icon>mdi-plus</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <thead>
            <tr>
              <th>Otsikko</th>
              <th>Kuvaus</th>
              <th>Suodatin</th>
              <th>% Katsotaan</th>
              <th>Näkymä</th>
              <th>Event Key</th>
              <th>Analyysivaihe</th>
              <th>Sarjat</th>
              <th>Arkistoitu</th>
              <th>Toiminnot</th>
            </tr>
          </thead>
          <tbody>
            <QualityControlItemRow
              v-for="(item, idx) in localItems"
              :key="item.id || idx"
              :item="item"
              :editing="item.editing"
              @save="saveQCItem(idx, $event)"
              @edit="editQCItem(idx)"
              @archive="confirmArchive(idx)"
            />
          </tbody>
        </v-simple-table>
        <div v-if="localItems.length === 0" class="text-center pa-4">
          Ei laadunvalvontakohteita
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="close">Sulje</v-btn>
      </v-card-actions>
    </v-card>
    <ConfirmationDialog
      :show="archiveDialog.show"
      text="Arkistoidaan laadunvalvontakohde?"
      :subText="archiveDialog.item ? archiveDialog.item.title : ''"
      btnColor="red"
      btnText="Arkistoi"
      @accept="archiveConfirmed"
      @decline="archiveDialog.show = false"
    />
  </v-dialog>
</template>

<script>
import QualityControlItemRow from '@/components/quality/QualityControlItemRow.vue'
import ConfirmationDialog from '@/components/ConfirmationDialog.vue'
import ax from '@/utils/axios/axios.js'

export default {
  name: 'QualityControlDialog',
  components: { QualityControlItemRow, ConfirmationDialog },
  props: {
    value: Boolean,
    items: Array
  },
  data() {
    return {
      localItems: [],
      archiveDialog: { show: false, idx: null, item: null }
    }
  },
  computed: {
    dialogProxy: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    value(val) {
      if (val) {
        this.localItems = (this.items || []).map(i => ({ ...i }))
      }
    }
  },
  methods: {
    syncItems() {
      this.localItems = (this.items || []).map(i => ({ ...i }))
    },
    close() {
      this.$emit('input', false)
    },
    addQCItem() {
      this.localItems.push({
        id: null,
        title: '',
        description: '',
        filter: {},
        percentage_checked: 100,
        view: 'general',
        event_key: '',
        analysis_phase: 1.0,
        leagues: '',
        checked_date: '',
        archived: false,
        editing: true
      })
      this.emitUpdate()
    },
    editQCItem(idx) {
      this.localItems[idx].editing = true
    },
    async saveQCItem(idx, updatedItem) {
      const item = { ...this.localItems[idx], ...updatedItem }
      try {
        let res
        if (item.id) {
          res = await ax.put(`/quality/${item.id}`, {
            ...item,
            filter: item.filter,
            percentage_checked: item.percentage_checked,
            view: item.view,
            event_key: item.event_key,
            analysis_phase: item.analysis_phase,
            leagues: item.leagues
          })
        } else {
          res = await ax.post('/quality', {
            ...item,
            filter: item.filter,
            percentage_checked: item.percentage_checked,
            view: item.view,
            event_key: item.event_key,
            analysis_phase: item.analysis_phase,
            leagues: item.leagues
          })
        }
        this.$set(this.localItems, idx, { ...res.data, editing: false })
        this.emitUpdate()
      } catch (e) {
        // Optionally handle error
      }
    },
    confirmArchive(idx) {
      this.archiveDialog = { show: true, idx, item: this.localItems[idx] }
    },
    async archiveConfirmed() {
      const { idx, item } = this.archiveDialog
      if (item.id) {
        try {
          await ax.put(`/quality/${item.id}`, { ...item, archived: true })
          this.localItems[idx].archived = true
          this.emitUpdate()
        } catch (e) { /* handle error if needed */ }
      } else {
        this.localItems.splice(idx, 1)
        this.emitUpdate()
      }
      this.archiveDialog = { show: false, idx: null, item: null }
    },
    emitUpdate() {
      this.$emit('update-items', this.localItems.map(i => ({ ...i })))
    }
  }
}
</script>